<template>
    <div class="lottie">
        <lottie
            :options="defaultOptions"
            :height="500"
            :width="500"
            @animCreated="handleAnimation"
        />
    </div>
</template>

<script>
import Lottie from 'vue-lottie'
import animationData from '@/json/parade.json'

export default {
  components: { Lottie },
  data() {
    return {
      defaultOptions: {
        animationData,
        loop: false,
        autoplay: true
      }
    }
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim
    }
  }
}
</script>
<style lang="scss" scoped>
.lottie {
    position: absolute;
    top: -200px;
    left: 50%;
    transform: translateX(-50%);
}
</style>
